<template>

    <div class="animated fadeIn">  
        <b-card class="card-accent-info" header="Acompanhamento de Projetos">
            <b-card-body>

              <b-row>
                <b-col cols="auto" class="mr-auto">
                </b-col>
                <b-col cols="auto" class="">
                  <b-form-group>
                    <b-button variant="github" class="mr-1 btn-brand" @click="openModalPDF(17)"><i class="fa fa-file-pdf-o"></i><span>Relatório de Acompanhamento</span></b-button>
                  </b-form-group>
                </b-col>
              </b-row>

            <b-row>
                <b-col cols="auto">
                <b-form-group>
                    <label for="company" style="font-size: 0.8em">Empresa</label>
                    <b-form-select id="company"
                        v-model="filters.companyId"
                        :plain="true"
                        :options="companyDDL"
                        @change="refreshData()"
                        >
                    </b-form-select>
                </b-form-group>
                </b-col>
    
                <b-col cols="auto">
                    <b-form-group >
                        <label for="startDate">Data</label>
                        <b-form-input v-model="filters.startDate" type="date" id="startDate" @change="refreshData"></b-form-input>
                    </b-form-group>
                </b-col>


                <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                <b-form-group>
                    <p></p>
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                </b-form-group>
                </b-col>
    
            </b-row>


            <b-row>
        
            <b-col md="4">
              <div>
              <b-card
                class="card-accent-info" 
                header-tag="header"
                footer-tag="footer">
                <div slot="header">
                  <i class="fa fa-wrench"></i><strong> Mecânicos </strong><small></small>
                </div>
                <b-list-group>
                  <b-list-group-item href="#" v-for="item in resourceMechanic" v-bind:key="item.id" :class="item.className" style="height: 18px; padding-top: 0px">
                    <div style="font-size: 0.8em">{{  item.alias ? item.alias : item.name }}</div>
                </b-list-group-item>
                </b-list-group>
              </b-card>
            </div>
             
              
            </b-col>
            <b-col md="4">
              <div>
              <b-card
                class="card-accent-info" 
                header-tag="header"
                footer-tag="footer">
                <div slot="header">
                  <i class="fa fa-user-plus"></i><strong> Ajudantes </strong><small></small>
                </div>
                <b-list-group>
                    <b-list-group-item href="#" v-for="item in resourceAuxiliar" v-bind:key="item.id" :class="item.className" style="height: 18px; padding-top: 0px">
                      <div style="font-size: 0.8em">{{ item.alias ? item.alias : item.name }}</div>
                    </b-list-group-item>
                </b-list-group>
              </b-card>
              </div>
             
            </b-col>
            <b-col md="4">
              <b-card
                class="card-accent-info" 
                header-tag="header"
                footer-tag="footer">
                <div slot="header">
                  <i class="fa fa-car"></i><strong> Veículos </strong><small></small>
                </div>
                <b-list-group>                
                  <b-list-group-item href="#" v-for="item in vehicleDDL" v-bind:key="item.id" :class="item.className" style="height: 18px; padding-top: 0px">
                    <div style="font-size: 0.8em">{{ item.text }}</div>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
          

        </b-card-body>
      </b-card>


    
        


      <b-card class="card-accent-info" header="Projetos">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                 <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Dispositivo</span></b-button>
                -->
               
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
      
  
            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>

   
           <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="statusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                <template #row-details="row">
                    <b-card>
                    
                        <b-row>
  
                            <b-col class="small">Contato</b-col>
                            <b-col class="text-primary">{{ row.item.name }}</b-col>
                            <b-col class="small">Telefone</b-col>
                            <b-col class="text-primary">{{ row.item.phone1 }}</b-col>
                            <b-col class="small">E-mail</b-col>
                            <b-col class="text-primary">{{ row.item.email }}</b-col>
                    
                        </b-row>
                    
                        <b-row v-show="row.item.address && row.item.address.length > 0">
                    
                            <b-col class="small">Endereço</b-col>
                    
                        </b-row>
                    
                        <b-row>
                    
                            <b-col class="text-primary">{{ row.item.address }} {{ row.item.addressNumber ? ", " + row.item.addressNumber : ""}}
                    
                                <br>{{ row.item.complement ? row.item.complement + " - " : "" }} {{ row.item.district }}
                    
                                <br>{{ row.item.city }} - {{ row.item.stateCode }}
                    
                                <br>CEP: {{ row.item.zipCode }}
                    
                            </b-col>
                    
                        </b-row>
                    </b-card>

                </template>                                    

                <template v-slot:cell(action)="data">
                  <!--
                          <b-button size="sm" variant="primary" @click="clone(data.item)" class="mr-1 btn-brand" title="Clonar" style="margin-bottom: 4px">
                          <i class="fa fa-clone"></i></b-button>
                    -->
                          <b-button size="sm" variant="css3" @click="openCommentModal(data.item)" class="mr-1 btn-brand" title="Comentário" style="margin-bottom: 4px">
                          <i class="fa fa-comment"></i></b-button>
                          <b-button size="sm" variant="dropbox" @click="openActionModal(data.item)" class="mr-1 btn-brand" title="Ação" style="margin-bottom: 4px">
                          <i class="fa fa-tasks"></i></b-button>
                          <b-button size="sm" variant="linkedin" @click="openImageModal(data.item)" class="mr-1 btn-brand" title="Imagens" style="margin-bottom: 4px">
                          <i class="fa fa-file-image-o"></i></b-button>
                          <b-button size="sm" variant="primary" @click="openItemModal(data.item)" class="mr-1 btn-brand" title="Itens" style="margin-bottom: 4px" v-if="false">
                          <i class="fa fa-money"></i></b-button>
                          <b-button size="sm" variant="primary" @click="openProductModal(data.item)" class="mr-1 btn-brand" title="Itens" style="margin-bottom: 4px">
                          <i class="fa fa-money"></i></b-button>
                          
                    </template>
                

                <template v-slot:cell(name)="data">
                        {{ data.item.name }}<br>
                        <span class="text-primary" v-if="data.item.description">{{ data.item.description }} <br></span>
                        <span class="text-primary" v-if="data.item.contact">{{ data.item.contact + " | Tel: " + data.item.phone1}}<br></span>
                        <span class="text-danger" v-if="data.item.notes">{{ data.item.notes }} <br></span>
                        
                    </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

                <template v-slot:cell(startDate)="data">
                        {{ $utils.dateStringFormat(data.item.startDate) }}                        
                    </template>

                <template v-slot:cell(teamTemplate)="data">

                    <b-list-group>
                      <b-list-group-item href="#" v-for="item in data.item.teams" v-bind:key="item.id" :class="item.color.className" style="min-height: 18px; padding-top: 0px">
                        <div style="font-size: 0.8em">{{  item.name }}</div>
                      </b-list-group-item>
                    </b-list-group>
             
                </template>
                
                <template v-slot:cell(vehicleTemplate)="data">
                    <b-list-group>
                      <b-list-group-item href="#" v-for="item in data.item.vehicles" v-bind:key="item.id" :class="item.resourceColor.className" style="min-height: 18px; padding-top: 0px">
                        <div style="font-size: 0.8em">{{  item.licensePlate }}</div>
                      </b-list-group-item>
                    </b-list-group>

                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>

     <b-modal
        v-model="productModal"
        id="product-modal"
        centered
        hide-footer
        title="Produtos e Serviços"
        size="xl">

        <project-prospect-component
          :companyId = "filters.companyId"
          :projectId = "selectedItem.id"
          :projectName = "selectedItem.name"
        ></project-prospect-component>

    </b-modal>

     <b-modal
              v-model="resourceModal"
              id="resource-modal"
              centered
              hide-footer
              title="Recursos"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
        <div class="animated fadeIn">

            Recursos
      
        </div>
        </b-form>
    </b-modal>


    

    <b-modal
              v-model="imageModal"
              id="image-modal"
              centered
              hide-footer
              title="Arquivos da Obra"
              size="xl">

              <div class="row text-center text-lg-start" v-if="projectImages && projectImages.length > 0">
              <div class="col-lg-3 col-md-4 col-6" v-for="item in projectImages" :key="item.id">
                <a href="#" class="d-block mb-4 h-100">
                  <img class="img-fluid img-thumbnail" :src="item.url" alt="" @click="openFileModal(item)">
                </a>
              </div>            
            </div>

            <div class="container" v-else>
                  <div class="row">
                      <div class="col-12" style="height: 100px">
                          <h3 class="gallery-title">Nenhum arquivo disponível</h3>
                      </div>
                  </div>
            </div>
      
            <b-card v-show="projectDocs">
              <b-table :items="projectDocs" :fields="fileFields" :select-mode="fileSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
                      per-page="50" current-page="1" :busy="isBusyFile" hover striped>
                    

                <template #table-busy>

                  <div class="text-center text-danger my-2">

                      <b-spinner class="align-middle"></b-spinner>

                      <strong>Carregando...</strong>

                  </div>
                </template>
                              
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    
                                      <span aria-hidden="true">&check;</span>
                    
                                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template v-slot:cell(createdIn)="data">
                    {{ $utils.localDateTimeShort( data.item.createdIn ) }}
                </template>

                <template v-slot:cell(action)="data">
                  <b-button size="sm" variant="primary" @click="openFileModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                </template>
              </b-table>
            </b-card>

            <b-card>
              <b-form @submit.stop.prevent="onSubmit">

                <div class="d-flex mb-3">
                    <file-drop-area-component v-model="fileToSend" class="w-100"></file-drop-area-component>
                </div>
                <p></p>
                <div class="d-flex mb-3  justify-content-center">
                    <b-button :disabled="!fileToSend" variant="primary" @click="uploadFile">Enviar Arquivo</b-button>
                </div>    

                </b-form>
            </b-card>

     </b-modal>



     <b-modal
              v-model="actionModal"
              id="action-modal"
              centered
              hide-footer
              title="Obra"
              size="lg">

          <b-card header="Atendimento">
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>

            <b-row>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Status</label>
                            <b-form-select v-model="editStatusId" id="filterStatus" :plain="true" :options="this.editStatusDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
            </b-row>     
       

            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveAction()"><i class="fa fa-check"></i><span>Salvar Atendimento</span></b-button>
            
            </div>

          </b-card>

     </b-modal>


     <b-modal
              v-model="commentModal"
              id="comments-modal"
              centered
              hide-footer
              title="Obra"
              size="lg">

          <b-card header="Comentários">
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>


            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveComment()"><i class="fa fa-check"></i><span>Salvar Comentário</span></b-button>
            
            </div>

          </b-card>

     </b-modal>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Acompanhamento"
              size="lg">
  
      <b-nav fill>
        <b-nav-item :active="tabInfo=='A'" @click="tabInfo='A'">Acompanhamento</b-nav-item>
        <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>
      </b-nav>

      <div v-show="tabInfo=='H'">
        <b-card>   
          
                
          <b-row>
              <b-col md="12">
              
                <b-table :items="projectDetail" :fields="projectDetailFields" :select-mode="projectDetailSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left 

                per-page="50" current-page="1" :busy="isBusyProjectDetail" hover striped>

                  <template #table-busy>
  
                    <div class="text-center text-danger my-2">
  
                        <b-spinner class="align-middle"></b-spinner>
  
                        <strong>Carregando...</strong>
  
                    </div>
                  </template>
                                
                  <!-- Example scoped slot for select state illustrative purposes -->
                  <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                      
                                        <span aria-hidden="true">&check;</span>
                      
                                        <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      
                      <span class="sr-only">Not selected</span>
                  </template>
                                </template>
                  <template v-slot:cell(createdIn)="data">
                      {{ $utils.localDateTimeShort( data.item.createdIn ) }}
                  </template>
                                                      
                  <template v-slot:cell(templateDescription)="data">
                      <span class="text-primary">{{ data.item.detailTypeName }}</span><br>
                      {{ data.item.description }}
                  </template>
                                                      
                                
                </b-table>
                
              </b-col>
            </b-row>


        </b-card>
      </div>
      
      <div v-show="tabInfo=='A'">

        <b-card>

          <b-form @submit.stop.prevent="onSubmit">
    
          <div class="animated fadeIn">
        
          <!--
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Id"
                  label-for="id"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>
          -->
    
            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Observação"
                  label-for="code">
                    
                  <b-form-textarea
                            id="description"
                            v-model="commentContent"
                            placeholder=""
                            rows="5"
                          ></b-form-textarea>

                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>
    
            <div v-for="item in teamList" :key="item.id">
            <hr>
              <b-row>
                <b-col md="12">
                  
                  <b-form>
                    <b-form-group
                    description=""
                    :label="'Equipe ' + item.id"
                    label-for="team"
                    :label-cols="3"
                    :horizontal="true">


                    <b-row>
                      <b-col>
                        <b-form-select id="team"
                        v-model="item.teamId"
                        :plain="true"
                        :options="teamDDL"
                        value="">
                      </b-form-select>
                      </b-col>
                      <b-col cols="2">
                        
                      </b-col>
                      <b-col cols="5">
                        
                      </b-col>
                    </b-row>
                    
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  
                  <b-form>
                    <b-form-group
                    description=""
                    label="Cor Equipe"
                    label-for="team"
                    :label-cols="3"
                    :horizontal="true">


                    <b-row>
                      <b-col>
                        <b-form-select id="teamColor"
                        v-model="item.colorId"
                        :plain="true"
                        :options="colorDDL"
                        value="">
                      </b-form-select>
                      </b-col>
                      <b-col cols="2">
                        Veículo
                      </b-col>
                      <b-col cols="5">
                        <b-form-select id="vehicle"
                          v-model="item.vehicleId"
                          :plain="true"
                          :options="vehicleDDL"
                          value="">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row v-show="!item.teamId || item.teamId.size > 0">
                <b-col md="12">
                  
                  <b-form>
                    <b-form-group
                    description=""
                    label="Recursos"
                    label-for="team"
                    :label-cols="3"
                    :horizontal="true">


                    <b-row>
                      <b-col>
                        
                        <v-select v-model="item.users" multiple :options="listResourceDDL" placeholder="Selecionar recursos" key="id" label="alias"></v-select>
                      </b-col>
                    </b-row>
                    
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
            </div>

    
          
                  
          </div>
        </b-form>

         <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Acompanhamento</span></b-button>
           
          </div>
        </b-card>

      </div>
  
      </b-modal>


      
      <b-modal :title="selectedFile.filename" class="modal-danger" v-model="fileModal" @ok="fileModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedFile">
          <div class="ratio ratio-16x9">
           
              <iframe
              :src="this.selectedFile.url"
              :title="this.selectedFile.filename"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>

      <b-modal title="Documentos e Formulários" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
          <div class="ratio ratio-16x9">
              <iframe
              :src="this.selectedDocument"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>

  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  import vSelect from 'vue-select'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  import ProjectProspectComponent from './ProjectProspectComponent.vue'
  import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
 
  

  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      vSelect,
      ProjectProspectComponent,
      FileDropAreaComponent
    },
    data: () => {
      return {
        selectedDocument: null,
        productModal: false,

        tabInfo: "A",
        teamList: [],
        colorDDL: [],
        
        // Histórico
        isBusyProjectDetail: false,
            projectDetailFields: [
              { key: 'createdIn', label: 'Data', sortable: true, thStyle: { width: "100px" }, class: 'text-center'},
              { key: 'templateDescription', label: 'Descrição', sortable: true },
              //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
            ],
            projectDetailSelectMode: 'single',
            projectDetail: [],

            // Modal dos arquivos não Imagem
          projectFiles: [],
          selectedFile: null,
          fileModal: false,

          isBusyFile: false,
          fileItems: [],
          fileFields: [
            { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
            { key: 'filename', label: 'Arquivo', sortable: true },
            { key: 'description', label: 'Descrição', sortable: true},
            
          ],
          fileSelectMode: 'single',


            fileToSend: null,

        commentContent: null,
        editStatusId: 0,

        itemModal: false,
            imageModal: false,
            actionModal: false,
            commentModal: false,
            documentModal: false,
     
            statusFullDDL: [],

        vehicleDDL: [],
       statusDDLFull: [],
        resourceDDL: [],

        teamDDL: [],
    
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],
  
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        resourceModal: false,
        filters: {
          companyId: 0,
          key: '',
          statusId: 0,
          startDate: null
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "40px" } },
          {key: 'id' },
          { key: 'code', label: 'Código', sortable: true, thStyle: { width: "100px" } },
       
          {key: 'name', label: 'Obra', sortable: true },
          { key: 'startDate', label: 'Início', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
          //{ key: 'confDate', label: 'Conferido', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
         // { key: 'endDate', label: 'Término', sortable: true, class: 'text-center', thStyle: { width: "100px" } },

          {key: 'teamTemplate', label: 'Equipe', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          {key: 'vehicleTemplate', label: 'Veículo', sortable: true, class: 'text-center', thStyle: { width: "70px" } },
          {key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          
          { key: 'action', label: '', sortable: false, thStyle: { width: "120px" } },
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {

      listResourceDDL() {
          var list = this.resourceDDL.sort((a,b) => (a.alias > b.alias) ? 1 : -1)
          return list;
      },

      projectImages() {
          var list = this.projectFiles.filter(item => {
              return item.typeId == 1
          })
          return list;
        },

        projectDocs() {
          var list = this.projectFiles.filter(item => {
              return item.typeId != 1
          })
          return list;
        },
      
      editStatusDDL() {
          var list = this.statusFullDDL.filter(item => {
              return item.parent.includes(1)
          })
          return list;
        },

        statusDDL() {

            var list = [...this.statusFullDDL]
            list = list.filter(item => {
              return !item.nextStatusId;
            })
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)

            list.unshift({ value: 'F' , text: '- Fechados -' })
            list.unshift({ value: 'C' , text: '- Cancelados -' })
            list.unshift({ value: 'A' , text: '- Abertos -' })
            list.unshift({ value: '0' , text: '- Todos -' })

            return list
 
        },
        

      totalRows: function () { return this.getRowCount() },


      resourceMechanic() {
        var item = this.resourceDDL.filter(item => {
            return( item.projectResource == 2 || item.projectResource == 5 || item.projectResource == 6 )
        })
        return item;
      },

      resourceAuxiliar() {
        return this.resourceDDL.filter(item => {
            return( item.projectResource == 3 )
        })
       
      },

      filteredItems() {
          try {
              return this.items.filter(item => {
                return(
                  (this.filters.statusId == 0 || item.statusId == this.filters.statusId || item.mainStatusId == this.filters.statusId))
                  && (this.filters.key == '' || 
                    (
                      item.erpCode == this.filters.key
                      || this.$utils.filterString(item.name, this.filters.key)
                    )
                  )
                
              })
          } catch (e) {
              return this.items;
          }
      }
    },
    methods: {
      openModalPDF(reportId) {
          var currentUser = this.$store.state.currentUser;
          this.selectedDocument = this.$store.state.ws_url + "/project/report/followup?companyId=" + this.filters.companyId + "&reportId=" + reportId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid;
          this.documentModal = true;
      },
      
      openProductModal(item) {
        this.selectedItem = item
        this.productModal = true
      },
      closeProductModal() {
          this.productModal = false
      },

      async uploadFile() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        let formData = new FormData();

        formData.append('companyId', this.filters.companyId)
        formData.append('projectId', this.selectedItem.id)
        formData.append('file', this.fileToSend);
        formData.append('uid', currentUser.id);
        formData.append('sid', currentUser.sid);

        await axios.post(
            this.$store.state.ws_url + "/project/file/upload", formData
        ).then(function() {
          s.fileToSend = null
          s.getProjectFiles(s.selectedItem)
          toast({
              type: VueNotifications.types.info,
              title: 'Arquivo',
              message: "Arquivo salvo com sucesso",
              timeout: 5000
          })
          
        }).catch(function (error) {
          console.log(error);
        });

      },

      openFileModal(item) {
              this.selectedFile = item;
              this.fileModal=true;
        },

        
      async getProjectFiles(item) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/project/file?projectId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.projectFiles = resp.data.obj;
          }).catch(function(error) {
            console.log(e)
          })
          ;
          this.isBusy = false;
        },


      clone(item) {

        this.$confirm("Deseja realmente clonar o item?").then(() => {
            console.log("Inicio da clonagem...")
            this.selectedItem = { ...item }
            this.selectedItem.id = null;
            this.selectedItem.code = null;
            this.selectedItem.vehicleApprovalId = null;
            this.selectedItem.vehicleApprovalIn = null;
            this.selectedItem.startDate = this.$utils.dateFormat(new Date());
            this.selectedItem.endDate = null;


            this.editModal = true;

            toast({
                    type: VueNotifications.types.success,
                    title: 'Clone',
                    message: "Obra clonada. Salve após efetuar as alterações desejadas.",
                    timeout: 5000
                })
        }).catch(function(error) {

        }) ;


        /*
        var dialog = confirm("Deseja realmente clonar o item?");
        if(dialog) {
          console.log("Inicio da clonagem...")
        }
        */

      },

      closeItemModal() {
          this.itemModal = false;
        },
        openItemModal(item) {
          this.commmentContent = ''
          this.itemModal = true;
        },

        closeImageModal() {
          this.imageModal = false;
          
        },
        openImageModal(item) {

          this.imageModal = true;
          this.getProjectFiles(item);
          this.selectedItem = item;

        },

        closeCommentModal() {
          this.commentModal = false;
        },
        openCommentModal(item) {
          this.commmentContent = ''
          this.selectedItem = item
          this.commentModal = true;
        },

        closeActionModal() {
          this.actionModal = false;
        },

        openActionModal(item) {
          this.commmentContent = ''
          this.selectedItem = item
          this.editStatusId = item.statusId
          this.actionModal = true
        },
  
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
  
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },
  
      async saveItem() {
  
        var s = this;
        var postData = {} ;
        var resources = s.teamList


        postData["companyId"] = s.filters.companyId
        postData["projectId"] = s.selectedItem.id
        postData["date"] = s.filters.startDate.length == 10 ? s.filters.startDate + 'T12:00:00' : s.filters.startDate 
        postData["description"] = s.commentContent
        postData["resources"] = resources
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid

        console.log(postData)

        await axios.post(
            this.$store.state.ws_url + "/project/followup",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
  
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
  
    },
  
    save() {
  
        let msgError = [];
  
        /*
        if(!this.commentContent || this.commentContent.length <= 5)
            msgError.push("Observação");
        */

        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )
  
            toast ({
                type: VueNotifications.types.error,
                title: 'Campos Obrigatórios',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem();
        }
    },

    closeResourceModal() {
        this.resourceModal = false;
    },

    openResourceModal(item) {
        if(item == null) {
            this.selectedItem = item
        }
    },
  
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.tabInfo = "A"

        this.teamList = Array.from([
          { id: 1, teamId: null, colorId: null, vehicleId: null, users: []},
          { id: 2, teamId: null, colorId: null, vehicleId: null, users: []},
          { id: 3, teamId: null, colorId: null, vehicleId: null, users: []}
        ])

        this.getTeam()
        this.getProjectDetail(item);
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },

      refreshColor() {

        
          var s = this
          this.items.forEach(function(item) {
            if(item.followupDetailId && item.followupDetailId > 0) {
              
              try {
                if(item.resources) {               
                  item.resources.forEach(function(vitem) {
                    var fresource = s.resourceDDL.find(obj => parseInt(obj.id) === vitem.id)
                    if(fresource) {
                      fresource.className = vitem.resourceColor.className
                    }
                  })
                }
              }
              catch(error) {
                console.log(error)
              }

              try {
                if(item.vehicles) {
                  item.vehicles.forEach(function(vitem) {
                    var fvehicle = s.vehicleDDL.find(obj => parseInt(obj.value) === vitem.id)
                    if(fvehicle) {
                      fvehicle.className = vitem.resourceColor.className
                    }
                  })
                }
              }
              catch(error) {
                console.log(error)
              }

            }
          })
          
       
      },

      async saveComment() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        if(this.selectedItem != null && this.commentContent != null && this.commentContent.length > 0)  {
          var postData = { projectId: this.selectedItem.id, statusId: 5, description: this.commentContent, uid: currentUser.id, sid: currentUser.sid }

          await axios.post(
                this.$store.state.ws_url + "/project/action",
                postData
            ).then(function (resp) {
                s.closeCommentModal();
            }
            ).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
               
            });
        }

      },

      async refreshStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
                this.$store.state.ws_url + "/project/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.statusDDLFull = resp.data.obj;
            }
            ).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
               
            });
      },

      async getVehicle(companyId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/fleetvehicle/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.vehicleDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },

        async getColor() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            //console.log(this.$store.state.ws_url + "/color/ddl?type=class")

             await axios.get(
                this.$store.state.ws_url + "/color/ddl?type=class"

            ).then(function(resp) {
              s.colorDDL = resp.data.obj
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },

        async getTeam() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
           
            await axios.get(
                this.$store.state.ws_url + "/team/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.teamDDL = resp.data.obj
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },
        
      async getResources(companyId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/project/resource?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              /*
              var rlist = resp.data.obj;
              
              rlist.forEach(function(item) {
                item.className='red'
              })

              s.resourceDDL = rlist
              */
              s.resourceDDL = resp.data.obj
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },

      async getStatus() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/project/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
                s.statusFullDDL = resp.data.obj;
            })            
            .catch(function(error) {
                console.log(error);
            });
            
        },

        async getProjectDetail(item) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/project/detail?projectId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.projectDetail = resp.data.obj;
          }).catch(function(errro) {
            console.log(e)
          })
          ;
          this.isBusy = false;
        },

      async refreshData() {
            this.getVehicle();
            this.getResources();

            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;
        
    
            await axios.get(
                this.$store.state.ws_url + "/project/followup?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&startDate=" + s.filters.startDate
            ).then(function (resp) {
                s.items = resp.data.obj;                
                s.refreshColor()
            }
            ).catch(function (error) {
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Erro',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });
  
            this.isBusy = false;
        
      }

    },
    mounted: function() {

      this.filters.startDate = this.$utils.dateFormat(new Date())
      this.filters.statusId = 9

      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
  
      this.getStatus();
      this.getColor();
      this.refreshStatus();

      this.refreshData();
    }
  }
  </script>
  
  <style scoped>

.blue {
  background-color: #007bff;
  color: white;
}

.indigo {
  background-color: #6610f2;
  color: white;
}

.purple {
  background-color: #6f42c1;
  color: white;
}

.pink {
  background-color: #e83e8c;
  color: white;
}

.red {
  background-color: #dc3545 ;
  color: white;
}

.orange {
  background-color: #fd7e14;
  color: white;
}

.yellow {
  background-color: #ffc107;
  color: white;
}

.green {
  background-color: #28a745;
  color: white;
}

.teal {
  background-color:  #20c997;
  color: white;
}
.cyan {
  background-color: #17a2b8;
  color: white;
}

  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>